import { render, staticRenderFns } from "./exhibition-card.vue?vue&type=template&id=9a1fd730&scoped=true&"
import script from "./exhibition-card.vue?vue&type=script&lang=js&"
export * from "./exhibition-card.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-card.vue?vue&type=style&index=0&id=9a1fd730&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1fd730",
  null
  
)

export default component.exports